<template>
  <div class="page">
    <div class="pagetitle">
      <h1>Счета</h1>
      <nav>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
          <li class="breadcrumb-item active">Счета</li>
        </ol>
      </nav>
    </div>

    <AccountBlock
        :initial="initial"
        :accounts="accounts"
        @update="openEdit"
        @delete="openDelete"
        @add="openCreate"
        @drag="onDragEnd"
    />

    <p v-if="loading">Loading...</p>

    <br>

    <BaseModal
        v-if="isEditOpen"
        title="Изменить счет"
        @close="closeEdit"
    >
      <AccountForm
          :initial="initial"
          :currencies="currencies"
          :error-message="messageError"
          @submit="onUpdate"
          @cancel="closeEdit"
      />
    </BaseModal>

    <BaseModal
        v-if="isCreateOpen"
        title="Добавить счет"
        @close="closeCreate"
    >
      <AccountForm
          :initial="initial"
          :currencies="currencies"
          :error-message="messageError"
          @submit="onAdd"
          @cancel="closeCreate"
      />
    </BaseModal>

    <DeleteModal
        title="Подтвердите удаление"
        :isOpen="isOpenDelete"
        @accept="onDelete"
        @close="closeDelete"
    />
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from 'vue';
import AccountForm from "@/features/accounts/components/AccountForm.vue";
import {useAccounts} from "@/features/accounts/composables/useAccounts";
import AccountTable from "@/features/accounts/components/AccountTable.vue";
import BaseModal from "@/components/ui/components/BaseModal.vue";
import Pagination from "@/components/ui/components/Pagination.vue";
import router from "@/router";
import AccountBlock from "@/features/accounts/components/AccountBlock.vue";
import DeleteModal from "@/components/ui/components/DeleteModal.vue";

const {
  accounts,
  currencies,
  loading,

  isSuccess,
  messageError,
  messageSuccess,

  load,
  addAccount,
  updateAccountById,
  deleteAccountById,
  sortAccounts
} = useAccounts();

const isCreateOpen = ref(false);
const isEditOpen = ref(false);
const initial = reactive({});

const page = 1;
const size = 1000;

onMounted(async () => {
  await Promise.all([load(page, size)]);
});

function openCreate() {
  isCreateOpen.value = true;
}
function closeCreate() {
  isCreateOpen.value = false;
  for (var field in initial) {
    initial[field] = '';
  }
  messageError.value = "";
}
function openEdit(payload) {
  Object.assign(initial, payload);
  isEditOpen.value = true;
}
function closeEdit() {
  isEditOpen.value = false;
  for (var field in initial) {
    initial[field] = '';
  }
  messageError.value = "";
}

async function onAdd(payload) {
  await addAccount({
    name: payload.name,
    balance: Number(payload.balance || 0),
    currency: payload.currency,
  });
  if (isSuccess.value) {
    closeCreate();
    await load(page, size);
  }
}

function onUpdate(payload) {
  updateAccountById(payload.id, {
    name: payload.name,
    balance: Number(payload.balance),
  });
  if (isSuccess.value) {
    closeEdit();
  }
}

const isOpenDelete = ref(false);
const deleteObj = ref(null);
function openDelete(payload) {
  isOpenDelete.value = true;
  deleteObj.value = payload
}

function closeDelete() {
  isOpenDelete.value = false;
}

async function onDelete() {
  await deleteAccountById(deleteObj.value.id);
  deleteObj.value = null;
  isOpenDelete.value = false;
  await load(page, size);
}

const onDragEnd = async (accountCards) => {
  const sort = accountCards.map((acc, index) => ({
    id: acc.id,
    sort: index + 1
  }));

  await sortAccounts({accounts: sort});
  await load(page, size);
}

</script>

<style scoped>
.red-text {
  color: red;
}
.green-text {
  color: green;
}
</style>
